
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 4a1 1 0 011-1h16a1 1 0 011 1v14a3 3 0 01-3 3H6a3 3 0 01-3-3V4zm2 1v13a1 1 0 001 1h12a1 1 0 001-1V5H5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 14a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 17a1 1 0 01-1-1v-4a1 1 0 112 0v4a1 1 0 01-1 1zM3 8a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zM16 2a1 1 0 011 1v2a1 1 0 11-2 0V3a1 1 0 011-1zM8 2a1 1 0 011 1v2a1 1 0 01-2 0V3a1 1 0 011-1z"}})])
          )
        }
      }
    